import { formatarMilhares } from '@/utils';
import { v4 as uuidv4 } from 'uuid';

export default {
  SET_CRCS(state, payload) {
    const data = payload.data.map((crc) => {
      const newItems = crc.itens.map((item) => ({
        ...item,
        quantidadeServico: formatarMilhares(item.quantidadeServico),
        valorCalculado: formatarMilhares(item.valorCalculado),
        valorServico: formatarMilhares(item.valorServico),
        uuid: uuidv4(),
      }));

      const valorTotal = newItems.reduce((acc, value) => {
        const valorDesformatado = value.valorCalculado.replace(/\./g, '').replace(',', '.');

        return acc + Number(valorDesformatado);
      }, 0);

      return {
        ...crc,
        valorTotal: formatarMilhares(valorTotal),
        itens: newItems,
      };
    });

    Object.assign(payload, { data });
    state.crcs = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
};
